module.exports = __webpack_public_path__ + "static/media/Rohan.c5665e59.jpeg";